import {
    GetDatepickerTranslationAction,
    SetDatepickerTranslationAction,
} from "../../interfaces/store/actions/antdTranslation";
import {DatepickerLocale} from "../../interfaces/store/reducers/antdTranslationState";

export const GET_DATEPICKER_TRANSLATION = "GET_DATEPICKER_TRANSLATION";
export const SET_DATEPICKER_TRANSLATION = "SET_DATEPICKER_TRANSLATION";

export const getDatepickerTranslation = (payload: string): GetDatepickerTranslationAction => ({
    type: GET_DATEPICKER_TRANSLATION,
    payload,
});

export const setDatepickerTranslation = (payload: DatepickerLocale): SetDatepickerTranslationAction => ({
    type: SET_DATEPICKER_TRANSLATION,
    payload,
});
